import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Needs for remount react coomponents in alarm_zones table
    ReactRailsUJS.mountComponents();
    App.helpers.refresh_listeners('#alarm_zones')
  }
}
